<main class="esf-main-content -has-transition -width-max">
  <div class="esf-container main-content--full-screen">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span class="esf-action-heading__text">{{ i18nHeading }}</span>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">
          <button *ngIf="!spinnerService.isShowing(spinner)"
                  class="esf-button esf-button--filled esf-button--small"
                  (click)="isModalOpened = true; spinnerService.show(spinner)">
            {{ i18nHeadingButton }}
          </button>
          <app-spinner [name]="spinner"></app-spinner>
        </span>
      </span>
    </h1>

    <app-paginated-table [columns]="columns"
                         [keys]="keys"
                         [data]="data"

                         [baseApi]="baseApi"
                         [customQueries]="customQueries"
                         (dataFetchedEmitter)="showLotteries($event)"
                         [actionButtons]="actionButtons"

                         (rowButtonClickEvent)="actionButtonClicked($event)"
                         (rowClickEvent)="rowClicked($event)"

                         [emptyStateText]="i18nEmptyState"
                         [emptyStateIcon]="'#esf-icon-bell-32'">
    </app-paginated-table>

  </div>
</main>

<app-create-tixx-select *ngIf="isModalOpened"
                        (closeButton)="isModalOpened = false;">
</app-create-tixx-select>
